module.exports = __webpack_public_path__ + "img/profit.cb88d5ab.svg";